var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point-store_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M19.43 8.422H3.564a1 1 0 0 0-1 1v10.241a1 1 0 0 0 1 1H19.43a1 1 0 0 0 1-1V9.422a1 1 0 0 0-1-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M20.92 10.39a1 1 0 0 0 .903-1.43l-2.256-4.752a1 1 0 0 0-.904-.571h-1.358l1.906 6.753zM4.338 3.637a1 1 0 0 0-.904.57L1.178 8.962a1 1 0 0 0 .904 1.429h1.712l1.902-6.753z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#49B0FF",
  d: "M14.601 10.39h4.608l-1.906-6.753h-3.451zM9.15 3.637H5.7L3.796 10.39H8.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "m9.148 3.637-.75 6.753h6.204l-.75-6.753z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B8BDC8",
  d: "M9.6 12.561H6.695a1 1 0 0 0-1 1v7.102H10.6v-7.102a1 1 0 0 0-1-1"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDC30",
  d: "M19.023 23a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D6B100",
  d: "m20.376 16.648-.781 3.557H18.49l-.261-1.531-.336 1.53h-1.038l-.653-2.529 1.073-.264.21 1.515.3-1.64.877-.217.322 1.88.203-2.009zM21.732 17.266l-.523 2.058h-.832l.316-2.62zm-.592 2.783a.486.486 0 0 1-.472.498.486.486 0 0 1-.473-.498c0-.275.212-.498.473-.498.26 0 .472.223.472.498"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "point-store_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 3.637h22v17.027H.5z"
})))));
export default SvgPointStore;